import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { getPropertyDetail } from '../../../Redux/Slices/BON-Frontend/propertySlice';

export const BookingFooter = () => {
       const dispatch = useDispatch();

  const { propertyDetails } = useSelector(
    (state) => state.property
  );

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const pid = params.get("pid");

    if (pid) {
      dispatch(getPropertyDetail(pid));
    }
  }, [dispatch]);
    return (
        <>
            <footer className="bp-footer p-4">
                <div>
                    <div className="row g-3 py-5">
                        <div className="col-md-4">
                            <h5 className="fw-bold font-serif mb-4">
                                {propertyDetails?.DisplayName}
                            </h5>
                            <p className="text-secondary small mb-4">
                                {/* Redefining luxury hospitality through a lens of timeless elegance
                                and curated service. */}
                                {propertyDetails?.Address}
                            </p>
                            {/* <div className="d-flex gap-3 bp-text-primary-custom">
                                <span className="material-symbols-outlined">
                                    social_leaderboard
                                </span>
                                <span className="material-symbols-outlined">photo_camera</span>
                                <span className="material-symbols-outlined">alternate_email</span>
                            </div> */}
                        </div>
                        <div className="col-md-2">
                            <h6 className="bp-font-label-sm mb-4">Quick Links</h6>
                            <ul className="list-unstyled d-grid gap-3 small">
                                <li>
                                    <a href="#">Sitemap</a>
                                </li>
                                {/* <li>
                                    <a href="#">Careers</a>
                                </li> */}
                                <li>
                                    <a href="#">Contact Us</a>
                                </li>
                            </ul>
                        </div>
                        <div className="col-md-2">
                            <h6 className="bp-font-label-sm mb-4">Policies</h6>
                            <ul className="list-unstyled d-grid gap-3 small">
                                <li>
                                    <a href="#">Privacy Policy</a>
                                </li>
                                <li>
                                    <a href="#">Terms of Service</a>
                                </li>
                            </ul>
                        </div>
                        <div className="col-md-4">
                            <h6 className="bp-font-label-sm mb-4">Newsletter</h6>
                            <p className="small text-secondary mb-4">
                                Subscribe for exclusive offers and updates.
                            </p>
                            <div className="input-group">
                                <input
                                    className="form-control bp-newsletter-input"
                                    placeholder="Email Address"
                                    type="email"
                                />
                                <button className="btn bp-bg-primary-custom rounded-0">
                                    <span className="material-symbols-outlined">send</span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="border-top pt-4 text-center">
                        <p className="small text-secondary font-serif">
                            © 2024 {propertyDetails?.DisplayName}. All rights reserved.
                        </p>
                    </div>
                </div>
            </footer>
        </>
    )
}